<template>
  <div class="pop">
    <div class="box">
      <div class="top">考试分析导出</div>
      <div class="center">
        <div class="item">
          <span>导出链接：</span>
          <span>
            {{dataUrl}}
          </span>
        </div>
      </div>
      <div class="bottom">
        <Button style="margin-right:100px" @click="close">取消</Button>
        <a download="考试分析.xlsx" :href="dataUrl">下载</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["dataUrl"],
  methods: {
    close() {
      this.$emit("close");
    },
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.box {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.top {
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 18px;
  border-bottom: 1px solid #bbb;
  background: rgb(60, 91, 230);
  border-radius: 10px 10px 0 0;
  text-align: left;
  padding-left: 2em;
}
.item {
  margin-top: 20px;
}
/* .item span:first-child {
  display: inline-block;
  width: 100px;
  text-align: right;
} */
.bottom {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/exportA.vue